import { render, staticRenderFns } from "./DataGrid.vue?vue&type=template&id=8e1e9f0c&scoped=true&"
import script from "./DataGrid.vue?vue&type=script&lang=js&"
export * from "./DataGrid.vue?vue&type=script&lang=js&"
import style0 from "./DataGrid.vue?vue&type=style&index=0&id=8e1e9f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1e9f0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8e1e9f0c', component.options)
    } else {
      api.reload('8e1e9f0c', component.options)
    }
    module.hot.accept("./DataGrid.vue?vue&type=template&id=8e1e9f0c&scoped=true&", function () {
      api.rerender('8e1e9f0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lists/DataGrid.vue"
export default component.exports